export default function(ac, app) {
    var protetskiRad = app.getEntity('ProtetskiRad');

    protetskiRad.listView()
        .title('Protetski radovi')
        .icon('<i class="fa fa-archive fa-3x"></i>')
        .fields([
            ac.field('naziv')
                .cssClasses(['col-md-4']),
            // ac.field('tip')
            //     .cssClasses(['col-md-2']),
            ac.field('materijal', 'reference')
                .label('Materijal')
                .targetEntity(app.getEntity('Materijal'))
                .targetField(ac.field('naziv'))
                .cssClasses(['col-md-2']),
            ac.field('vrsta_rada', 'reference')
                .label('Vrsta rada')
                .targetEntity(app.getEntity('VrstaRada'))
                .targetField(ac.field('naziv'))
                .cssClasses(['col-md-2'])
        ])
        .listActions([
            'edit',
            'delete'
        ]);

    protetskiRad.editionView()
        .title('Protetski rad')
        .fields([
            {
                key:'naziv',
                type: 'hInput',
                templateOptions: {
                    label: 'Naziv',
                    required: true,
                    focus: true
                }
            },
            // {
            //     key: "tip",
            //     type: "hSelect",
            //     templateOptions: {
            //         label: "Tip rada",
            //         options: [
            //             {
            //                 name: "Fiksna",
            //                 value: "F"
            //             },
            //             {
            //                 name: "Mobilna",
            //                 value: "M"
            //             }
            //         ]
            //     }
            // },

           {
                key:'materijal',
                type: 'huiSelect',
                templateOptions: {
                    label: 'Materijal',
                    optionsAttr: 'bs-options',
                    ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                    valueProp: 'id',
                    labelProp: 'naziv',
                    placeholder: 'Odaberite materijal',
                    options: []
                },
                controller: ['$scope', 'DS', function ($scope, DS) {
                    DS.findAll('Materijal').then(function (response) {
                        $scope.to.options = response;
                    });
                }]
            },

            {
                key:'vrsta_rada',
                type: 'huiSelect',
                templateOptions: {
                    label: 'Vrsta rada',
                    optionsAttr: 'bs-options',
                    ngOptions: 'option[to.valueProp] as option in to.options | filter: $select.search',
                    valueProp: 'id',
                    labelProp: 'naziv',
                    placeholder: 'Odaberite vrstu rada',
                    options: []
                },
                controller: ['$scope', 'DS', function ($scope, DS) {
                    DS.findAll('VrstaRada').then(function (response) {
                        $scope.to.options = response;
                    });
                }]
            },
        ]);

    return protetskiRad;
}



// WEBPACK FOOTER //
// ./app/components/protetskiRad/config.js